import { render, staticRenderFns } from "./CourseDiscussAnswerModal.vue?vue&type=template&id=49e40a44&scoped=true"
import script from "./CourseDiscussAnswerModal.vue?vue&type=script&lang=js"
export * from "./CourseDiscussAnswerModal.vue?vue&type=script&lang=js"
import style0 from "./CourseDiscussAnswerModal.vue?vue&type=style&index=0&id=49e40a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e40a44",
  null
  
)

export default component.exports